import React from 'react';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import CelebrationRoundedIcon from '@mui/icons-material/CelebrationRounded';
import CurrencyExchangeRoundedIcon from '@mui/icons-material/CurrencyExchangeRounded';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse } from '@mui/material';
import { Stack } from '@mui/system';
import { getRuta } from '../../helpers/Helpers';
import NavItem from './NavItem';
import { sidebar } from '../../theme';

export const Configurations = ({ drawerIsOpen }) => {
	const [open, setOpen] = React.useState(false);
	let rout = getRuta();
	return (
		<div>
			<Box
				onClick={() => setOpen(!open)}
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '12px',
					padding: '10px 14px',
					borderRadius: '9px',
					cursor: 'pointer',
					color: sidebar.itemColor,
					marginBottom: '2px',
					'&:hover': { backgroundColor: 'rgba(255,255,255,.06)', color: '#e8edf3' }
				}}
			>
				<Box sx={{ display: 'flex', color: sidebar.iconColor, fontSize: 20 }}>
					<SettingsRoundedIcon fontSize="inherit" />
				</Box>
				<Box component="span" sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>
					Configuraciones
				</Box>
				{open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
			</Box>

			<Collapse in={open} timeout="auto" unmountOnExit>
				<Stack paddingLeft={drawerIsOpen ? 1.5 : 0} spacing={0.2}>
					<NavItem sub to={`${rout}/sucursales`} icon={<StoreRoundedIcon fontSize="inherit" />} label="Sucursales" />
					<NavItem sub to={`${rout}/locations`} icon={<LocationOnRoundedIcon fontSize="inherit" />} label="Ubicaciones" />
					<NavItem sub to={`${rout}/tasa-interes`} icon={<PercentRoundedIcon fontSize="inherit" />} label="Tasa de Interés" />
					<NavItem sub to={`${rout}/periodicidad`} icon={<EventRepeatRoundedIcon fontSize="inherit" />} label="Periodicidad" />
					<NavItem sub to={`${rout}/holidays`} icon={<CelebrationRoundedIcon fontSize="inherit" />} label="Días Festivos" />
					<NavItem sub to={`${rout}/tasa-cambio`} icon={<CurrencyExchangeRoundedIcon fontSize="inherit" />} label="Tasa de Cambio" />
				</Stack>
			</Collapse>
		</div>
	);
};
